import api from './api';

export const setUserKanbanLaneOrder = async (laneOrder, userId = null) => {
  try {
    const url = userId 
      ? `/user-kanban/lane-order/${userId}`
      : '/user-kanban/lane-order';
    
    const response = await api.post(url, {
      laneOrder
    });
    return response.data;
  } catch (error) {
    console.error('Error setting user kanban lane order:', error);
    throw error;
  }
};

export const getUserKanbanLaneOrder = async (userId = null) => {
  try {
    const url = userId 
      ? `/user-kanban/lane-order/${userId}`
      : '/user-kanban/lane-order';
    
    const response = await api.get(url);
    return response.data.laneOrder;
  } catch (error) {
    console.error('Error getting user kanban lane order:', error);
    return null;
  }
};
